import { createSlice } from '@reduxjs/toolkit';

import { getSkuDetails, saveShipmentDetails } from '../../apis';


export const CreateShipmentSlice = createSlice({
    name: 'newOrders',
    initialState: {
        getSkuDetailsIsLoading: false,
        skuDetailsData : [],
        error: '',
        confirmShipmentIsLoading: false
    },

    reducers: {
        updateBoxTrackingDetails: (state, action) => {
            return {
                ...state,
                skuDetailsData: {
                    ...state.skuDetailsData,
                    box_tracking: action.payload
                }
            }
        },
        skuDetailsQuantities: (state, action) => {
            return {
                ...state,
                skuDetailsData: {
                    ...state.skuDetailsData,
                    sku_details: [...(state.skuDetailsData.sku_details.filter(item => item.style_id !== action.payload.style_id)), action.payload]
                }
            }
        },
    },

    extraReducers: (builder) => {
        builder.addCase(getSkuDetails.pending, (state, action) => {
            state.getSkuDetailsIsLoading = true;
        })
        builder.addCase(getSkuDetails.fulfilled, (state, action) => {
            state.error = '';
            state.getSkuDetailsIsLoading = true;
            state.skuDetailsData = action.payload.data
        })
        builder.addCase(getSkuDetails.rejected, (state, action) => {
            state.error = action.payload.message
            state.getSkuDetailsIsLoading = false;
        })
        builder.addCase(saveShipmentDetails.pending, (state, action) => {
            state.confirmShipmentIsLoading = true;
        })
        builder.addCase(saveShipmentDetails.fulfilled, (state, action) => {
            state.error = '';
            state.confirmShipmentIsLoading = true;
        })
        builder.addCase(saveShipmentDetails.rejected, (state, action) => {
            state.error = action.payload.message
            state.confirmShipmentIsLoading = false;
        })
    }
})

export const { updateBoxTrackingDetails, skuDetailsQuantities } = CreateShipmentSlice.actions


export default CreateShipmentSlice.reducer